//商品詳細ページプログレスバー表示
(function progressBar(){
	const bar = document.querySelector('.progress-bar');
	// const barScroll = 10;
	var target = document.getElementById('product__media');
	target.addEventListener('scroll', function updateBar(){
		const windowScroll = target.scrollTop;
	//   const windowScroll = window.pageYOffset;
	  const docHeight = document.body.clientHeight;
	  const windowHeight = window.innerHeight;
	//   const scrollUnit = (windowScroll / (docHeight - windowHeight) * 100);
	  const scrollUnit = ((windowScroll / 2.5) / 10) - 5;
	  bar.style.height = scrollUnit + "%";
	})
}());
